module.exports = __webpack_public_path__ + "img/09.c277aaed.jpg";